import React from 'react';
import { css, useTheme } from '@emotion/react';
import { type ExperienceSimpleHeaderCard } from '@bbkAdminRedux/rtkq/experience.slice';
import { type RestExperience } from '@bbkAdminUtils/api-client/rest-experiences-api';
import { cs } from '@bbkAdminUtils/css-utils';
import { type EmotionTheme } from '@bbkFunnel/pages/theme';
import { makeClassNameSafe } from '@bbkFunnelUtils/utils';

import './top.scss';

type Props = {
  card: ExperienceSimpleHeaderCard;
  fullInfo: Pick<RestExperience, 'company'>;
};

export const SimpleHeader: React.FC<Props> = (props) => {
  const theme = useTheme() as EmotionTheme;
  const {
    card,
    card: {
      requires: { company: companyCard },
      style_overlay: customStyles,
    },
    fullInfo: { company: companyFullInfo },
  } = props;

  const hrColor = theme.headerBorder || theme.primaryColor;

  const centerLogo = theme.logoCenter;

  const company = companyFullInfo.brandingLogoActivated
    ? companyFullInfo
    : companyCard;

  const logoStyles = css({
    maxWidth: theme.logoMaxWidth || customStyles?.maxWidth || '250px',
  });

  const isFixedWidth = !theme.headerFullWidth;

  return (
    <div
      className={cs({ container: isFixedWidth }, makeClassNameSafe(card.name))}
    >
      <div
        className="top"
        css={{
          background: isFixedWidth ? 'transparent' : hrColor,
          padding: isFixedWidth ? '1rem 0rem 0.5rem 0rem' : '1rem',
        }}
      >
        <div
          className="details"
          style={{
            justifyContent: company.user_avatar
              ? 'space-between'
              : centerLogo
                ? 'space-around'
                : 'space-between',
          }}
        >
          <img
            className="full-logo"
            src={company.logo}
            alt={company.name || 'logo'}
            css={[logoStyles]}
          />
          {company.user_avatar && (
            <div>
              <img
                className="photo"
                src={company.user_avatar}
                alt={company.user_name}
              />
            </div>
          )}
        </div>
        {isFixedWidth && (
          <hr
            className="bbk-top-horizontal-rule"
            css={{
              background: hrColor,
            }}
          />
        )}
      </div>
    </div>
  );
};
